import React, { useCallback, useEffect, useState } from 'react'
import { IconSearch, IconTrash } from '@tabler/icons-react'
import authQueries from '../../queries/authQueries'
import Empty from '../../components/Empty'
import DrawerComponent from '../../components/DrawerComponent'
import { snackbarToast } from '../../components/SnackbarToast'
import Loader from '../../components/Loader'
import { useSelector } from 'react-redux'
import PaginationComponent from '../../components/PaginationComponent'
import { useApi } from '../../utils/ApiProvider'
import dropdownQueries from '../../queries/dropdownQueries'
import ConfirmationModal from '../../components/ConfirmationModal'
import { debounce } from 'lodash'
import vesselQueries from '../../queries/vesselQueries'


const VesselScreen = () => {

    const [result, setResult] = useState([])
    const [loader, setLoader] = useState(true)

    const page = useSelector((state)=> state.pagination.page)
    const size = useSelector((state)=> state.pagination.size)
    const { apiData, setApiDataAndNotify } = useApi()

    const [search, setSearch] = useState('')

    const getData = vesselQueries.useGetVessel(
        (res)=>{
            if(res?.success){
                setResult(res?.data)
            }
            setLoader(false)
        }
    )

    const debouncedSearch = useCallback(
        debounce((text) => {
            getData.mutateAsync({search: text, page, size})
        }, 300),
        []
    );
  
    useEffect(() => {
        debouncedSearch(search);
        return () => {
            debouncedSearch.cancel();
        };
    }, [search, page, size, apiData]);

    const inputFields = [
        {
            name: 'name',
            type: 'text',
            label: 'Vessel Name',
            placeholder: 'Vessel Name',
            required: true
        },
        {
            name: 'imo_number',
            type: 'text',
            label: 'IMO Number',
            placeholder: 'IMO Number',
            required: true
        },
        {
            name: 'category',
            type: 'text',
            label: 'Category',
            placeholder: 'Category',
            required: true,
        },
        {
            name: 'flag',
            type: 'text',
            label: 'Flag',
            placeholder: 'Flag',
            required: false
        },
        {
            name: 'classification',
            type: 'text',
            label: 'Classification',
            placeholder: 'Classification',
            required: false
        },
        {
            name: 'class_notation',
            type: 'text',
            label: 'Class Notation',
            placeholder: 'Class Notation',
            required: false
        },
    ]
    
    const create = vesselQueries.useCreateVessel(
        (res)=>{
            if(res?.success){
                setApiDataAndNotify(new Date())
                snackbarToast('Vessel Created Successfully', 'success')
            }
            if(!res?.success){
                if(res?.error?.length === 0){
                    snackbarToast(res?.message, 'error')
                    return
                }

                const errors = res?.error?.map((data) => {
                    return null;
                }).filter(Boolean);
                
                errors?.forEach((data) => snackbarToast(data, 'error'));
                
            }
        }
    )

    const update = vesselQueries.useUpdateVessel(
        (res)=>{
            if(res?.success){
                setApiDataAndNotify(new Date())
                snackbarToast('Vessel Updated Successfully', 'success')
            }
            if(!res?.success){
                if(res?.errors?.length === 0){
                    snackbarToast(res?.message, 'error')
                    return
                }
                
                const errors = res?.error?.map((data) => {
                    return null;
                }).filter(Boolean);

                errors?.forEach((data) => snackbarToast(data, 'error'));
                
            }
        }
    )

    const deleteVessel = vesselQueries.useDeleteVessel(
        (res)=>{
            if(res?.success){
                setApiDataAndNotify(new Date())
                snackbarToast('Vessel Deleted Successfully', 'success')
            }
        }
    )

    const handleDelete =(data)=>{
        deleteVessel.mutateAsync(data?.id)
    }

  return (

    <div className='card-shadow m-4 max-[768px]:m-2 bg-white rounded-[10px]'>

        <div className='flex justify-between max-[934px]:flex-col items-center p-6 gap-y-3'>
            <div>
                <p className='text-[13px] text-[#6D6B77] font-medium'>Showing {result?.totalItems} entries</p>
            </div>
            <div className='flex gap-2 max-[799px]:flex-col max-[799px]:w-full'>
                <div className='relative'>
                    <input onChange={(e)=>{setSearch(e.target.value)}} placeholder='Type to search...' className='w-[300px] max-[799px]:w-full h-[40px] border rounded-[7px] pl-10 pr-3 mt-[1px] text-[13px]' />
                    <IconSearch className='absolute top-[12px] left-4 text-secondary' size={16} />
                </div>
                <DrawerComponent entityForm={create} inputFields={inputFields} btnName={'Add Vessel'} header={'Add Vessel'} />
            </div>
        </div>

        {
            loader ?
            <div className="w-full flex items-center justify-center py-40">
                <Loader />
            </div>:
            <div className='px-6 pb-6'>
                {
                    result?.totalItems > 0 ?
                        <table className='table w-full'>
                            <thead>
                                <tr className='table-row'>
                                    <th>Sl No.</th>
                                    <th>Vessel Name</th>
                                    <th>IMO Number</th>
                                    <th>Category</th>
                                    <th>Flag</th>
                                    <th>Classification</th>
                                    <th>Class Notation</th>
                                </tr>
                            </thead>
                            <tbody>
                                {result?.items?.map((row, index) => {
                                    return(
                                        <tr key={index} className='table-row'>
                                            <td>{result?.currentPage * 10 + index + 1}</td>
                                            <td>{row?.name}</td>
                                            <td>{row?.imo_number}</td>
                                            <td>{row?.category}</td>
                                            <td>{row?.flag}</td>
                                            <td>{row?.classification}</td>
                                            <td>{row?.class_notation}</td>
                                            <td>
                                                <div className='flex gap-2 justify-end'>
                                                    <DrawerComponent entityForm={update} inputFields={inputFields} btnName={'Update Vessel'} header={'Update Vessel'} item={row} edit={true} />
                                                    <ConfirmationModal data={row} handle={handleDelete} color="danger" buttonContent="Delete" content={"Are you sure you want to delete this vessel?"}>
                                                        <IconTrash size="16" />
                                                    </ConfirmationModal>
                                                </div>
                                            </td>
                                        </tr>
                                    )}
                                )}
                            </tbody>
                        </table>:
                    <Empty />
                }
                <PaginationComponent result={result} />
            </div>
        }

    </div>
  )
}

export default VesselScreen